<div class="d-flex justify-content-end mt-2 btn-hover align-items-center" style="margin-right: 2px;" [ngStyle]="{ 'opacity': disabled ? '0.3' : '1' , 'cursor': disabled ? 'not-allowed' : 'pointer' }" >
  <img *ngIf="icone != null" [src]="'assets/img/icons/' + icone + '.svg'" alt="ícone olho" height="16px" width="16px" class="me-2"><span > {{ titulo }}</span>
</div>
